import React, { useState, useEffect, useLayoutEffect } from "react";
import { IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/react";
import { useTranslation } from "react-i18next";

import "./SortByEMSDropDown.scss";
import { dataTransferService } from "../../../services/dataTransferService";

/**
 * Drop down component
 * Component will show a drop down to select from list.
 * Component will return the selectd item id.
 */

interface DropDownItemProps {
  getSelectedItem: (value: number) => void;
  hideLabel: boolean;
  caseUpdated?: any;
}

const SortByEMSDropDown: React.FC<DropDownItemProps> = (props) => {
  const { t } = useTranslation("ems");
  var [selectedSortId, setSelectedSortId]: any = useState(0);

  useEffect(() => {
    props.getSelectedItem(selectedSortId);
  }, [selectedSortId]);

  useEffect(() => {
    if (props.caseUpdated) {
      props.getSelectedItem(0);
      setSelectedSortId(0);
    }
  }, [props.caseUpdated]);

  useLayoutEffect(() => {
    let sub = dataTransferService.getUpdateCaseDetails.subscribe(
      (data: any) => {
        if (data === true) {
          props.getSelectedItem(0);
          setSelectedSortId(0);
        } else {
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const sortByList = [
    {
      sortId: 0,
      name: t("active"),
    },
    {
      sortId: 1,
      name: t("all"),
    },
    {
      sortId: 2,
      name: t("completedCancelled"),
    },
  ];
  return (
    <div className="sort-by-dropdown-div">
      <IonItem lines="none">
        {!props.hideLabel && <IonLabel>{t("filterBy")}</IonLabel>}
        <IonSelect
          okText={t("ok")}
          cancelText={t("cancel")}
          value={selectedSortId}
          onIonChange={(e) => {
            setSelectedSortId(e.detail.value);
          }}
          multiple={false}
        >
          {sortByList.map((item) => (
            <IonSelectOption value={item.sortId} key={item.sortId}>
              {item.name}
            </IonSelectOption>
          ))}
        </IonSelect>
      </IonItem>
    </div>
  );
};

export default SortByEMSDropDown;
